import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Swift = () => {
  return (
    <StartInterviewLayout type="swift"/>
  )
}

export default Swift;